import { ReactNode } from 'react'
import { Link, Loader2 } from 'lucide-react'
import { DropdownMenuItem } from '@/components/ui/dropdown-menu'
import LinkButton from '@/components/ui/link-button'
import { cn } from '@/lib/utils'

type Props = {
  thumbnailUrl?: string | null
  title: string
  detail: ReactNode
  href?: string
  pending?: boolean
  disabled?: boolean
  selected?: boolean
  onSelect?: (event: Event) => void
}

const PreviousEventMenuItem = ({
  thumbnailUrl,
  title,
  detail,
  href,
  pending = false,
  disabled = false,
  selected = false,
  onSelect,
}: Props) => {
  return (
    <DropdownMenuItem
      disabled={disabled}
      onSelect={onSelect}
      className={cn(
        selected &&
          'bg-muted text-success-foreground focus:bg-muted focus:text-success-foreground data-[highlighted]:focus:bg-muted data-[highlighted]:focus:text-success-foreground',
      )}
    >
      <span className='flex w-full items-center gap-2'>
        {pending ? (
          <Loader2 className='h-8 w-8 animate-spin shrink-0 text-muted-foreground' />
        ) : thumbnailUrl ? (
          <img
            className='h-8 w-8 rounded-md border border-border shrink-0'
            src={thumbnailUrl}
          />
        ) : (
          <div className='h-8 w-8 rounded-md border border-border bg-muted shrink-0' />
        )}
        <span className='min-w-0 flex flex-col w-full'>
          <span className='truncate'>{title}</span>
          <div className='flex items-center justify-between gap-2 w-full'>
            <span className='text-xs text-muted-foreground'>{detail}</span>
            {href ? (
              <LinkButton
                to={href}
                target='_blank'
                rel='noreferrer'
                size='xs'
                onClick={(event) => {
                  event.stopPropagation()
                }}
                onMouseDown={(event) => {
                  event.stopPropagation()
                }}
              >
                <Link size={12} />
              </LinkButton>
            ) : null}
          </div>
        </span>
      </span>
    </DropdownMenuItem>
  )
}

export default PreviousEventMenuItem
